/* Red Line design: buy-box behaviour for the default product page.
 * Loaded by sections/main-product.liquid only when section.settings.red_line is on.
 * Pack rows, the price row and the eligibility line are Liquid; this file only
 * adds what needs the live page:
 *   - bar-shaped swipe dots on the phone gallery
 *   - the "50 rounds · Change" button in the sticky bar (scrolls to the packs)
 * Never touches the native radios, variant-selects, the cart forms or the
 * sticky select/qty, and re-applies itself after product-info re-renders. */
(function () {
  'use strict';

  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function primaryPicker() { return $('.product-info--offer-builder variant-selects[data-primary]'); }

  /* What's chosen, for the sticky bar:
     "1,000 Rounds - Case (20 Boxes)" -> "1,000 rounds", "1 Box - 25 Shells" -> "25 shells",
     anything else (sizes, colours, shot size) -> the chosen values, e.g. "Medium". */
  function packText() {
    var picker = primaryPicker();
    if (!picker) return '';
    var chosen = $$('input[type="radio"]:checked', picker).map(function (i) { return i.value || ''; });
    $$('select', picker).forEach(function (sel) { if (sel.value) chosen.push(sel.value); });
    for (var i = 0; i < chosen.length; i++) {
      var m = chosen[i].match(/([\d,]+)\s*(Rounds?|Shells?)\b/i);
      if (m) return m[1] + ' ' + m[2].toLowerCase().replace(/s?$/, 's');
    }
    return chosen.filter(Boolean).join(' / ');
  }

  /* ---------- phone gallery dots ---------- */
  function galleryDots() {
    var list = $('.product-info--offer-builder .product__media-wrapper ul[id^="Slider-Gallery"]');
    if (!list || list.dataset.rlDots) return;
    var slides = $$(':scope > li', list);
    if (slides.length < 2) return;
    list.dataset.rlDots = '1';
    var dots = document.createElement('div');
    dots.className = 'rl-dots';
    dots.setAttribute('aria-hidden', 'true');
    slides.forEach(function (_, i) {
      var d = document.createElement('span');
      if (i === 0) d.className = 'is-on';
      dots.appendChild(d);
    });
    list.parentNode.insertBefore(dots, list.nextSibling);
    var raf = 0;
    list.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = 0;
        // Slides are narrower than the list (the next one peeks), so pick the
        // slide whose left edge is closest to the scroll position.
        var i = 0, best = Infinity;
        slides.forEach(function (s, j) {
          var d = Math.abs(s.offsetLeft - list.offsetLeft - list.scrollLeft - parseFloat(getComputedStyle(list).paddingLeft || 0));
          if (d < best) { best = d; i = j; }
        });
        $$('span', dots).forEach(function (d, j) { d.classList.toggle('is-on', j === i); });
      });
    }, { passive: true });
  }

  /* ---------- sticky bar: pack label + change ---------- */
  function scrollToPacks() {
    var picker = primaryPicker();
    if (!picker) return;
    var top = picker.getBoundingClientRect().top + window.scrollY - 96;
    window.scrollTo({ top: Math.max(0, top), behavior: REDUCED ? 'auto' : 'smooth' });
    var target = $('input[type="radio"]:checked', picker) || $('input[type="radio"]', picker);
    if (target) {
      setTimeout(function () { target.focus({ preventScroll: true }); }, REDUCED ? 0 : 450);
    }
  }

  function stickyPack() {
    var bar = $('.product-info--offer-builder .sticky-atc--full') || $('.sticky-atc--full');
    var info = bar && $('.sticky-atc__info', bar);
    if (!info) return;
    var btn = $('.rl-sticky-pack', info);
    // Nothing to change on single-variant products: no button at all.
    if (!primaryPicker()) {
      if (btn) btn.remove();
      return;
    }
    if (!btn) {
      btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'rl-sticky-pack';
      btn.addEventListener('click', scrollToPacks);
      info.appendChild(btn);
    }
    var t = packText();
    var label = (t ? t + ' · ' : '') + 'Change';
    if (btn.textContent !== label) {
      btn.textContent = t ? t + ' · ' : '';
      var change = document.createElement('span');
      change.textContent = 'Change';
      btn.appendChild(change);
    }
    btn.setAttribute('aria-label', (t ? t + ' selected. ' : '') + 'Change selection');
  }

  function run() {
    galleryDots();
    stickyPack();
  }

  var queued = false;
  function queue() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; run(); });
  }

  function start() {
    run();
    var info = $('.product-info--offer-builder');
    if (info) new MutationObserver(queue).observe(info, { childList: true, subtree: true });
    document.addEventListener('change', function (e) {
      if (e.target && e.target.matches && e.target.matches('variant-selects input[type="radio"], variant-selects select')) queue();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
